import axios from 'axios';

const PORT = 3001;

export default axios.create({
    baseURL: 'https://slimpark.roaming.utwente.nl:' + PORT
})
